export default __webpack_public_path__ + "static/media/stepBlogger-1.aac87e15.svg";